import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import LinkIcon from '@/components/UI/svg/SaveElectric/Link';

export default function B() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('save_electric');

    return (
        <div className={`save-electric-b ${css.SaveElectricB}`}>
            <NextImage
                webpSrc={require('@publicLocal/save-electric/pc/3.webp')}
                src={require('@publicLocal/save-electric/pc/3.jpg')}
                alt={t('sec_2_title')}
                aria-label={t('sec_2_title')}
            />
            <div className="text-wrapper">
                <h2 className="title white">{t('sec_2_title')}</h2>
                <div className="desc">
                    {t.rich('sec_2_desc', {
                        p: (text: string) => <p className="p">{text}</p>,
                    })}
                </div>
                <Link
                    className="link_btn"
                    href="https://blog.ecoflow.com/jp/electricity-bill-increase/"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'select_news',
                        title_name: t('sec_2_title'),
                        button_name: t('sec_2_btn'),
                    }}
                >
                    {t('sec_2_btn')}
                    <span className="icon icon-white">
                        <LinkIcon />
                    </span>
                    <span className="icon icon-blue">
                        <LinkIcon stroke="#3f68e0" />
                    </span>
                </Link>
            </div>
        </div>
    );
}
